import React from "react";
import $ from 'jquery';
import { setDataToQt, resetData, dialog } from "./../projectScope/sqftIframe";

export default class ConfirmDialog extends React.Component {

  handleApplyClick = (e) => {
    if (dialog === "reset") {
      resetData();
      this.handleCloseClick();
    } else {
      setDataToQt();
      this.handleCloseClick();
    }
  };

  handleCloseClick = (e) => {
    $('.confirm-dialog-wrapper').fadeOut();
  };

  render() {
    return (
      <div className="full-screen-wrapper confirm-dialog-wrapper">
        <div className="message-window-base">
          <div className="message-system-message-title">System Message</div>
          <div className="message-blue-lable"/>
          <div className="message-system-text message-system-text-blue">
            <p id="systemMessageText"/>
          </div>
          <div className="message-box-buttons message-box-buttons--modal">
            <button className="ui-button ui-button--blue" onClick={this.handleCloseClick}>
              <span className="ui-button-text ui-button--uppercase">No</span>
            </button>
            <button className="ui-button ui-button--green" onClick={this.handleApplyClick}>
              <span className="ui-button-text ui-button--uppercase">Yes</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/common/confirmDialog.js